import { z } from 'zod';
import { BOMItemType } from '../../constants/bom-item-type.js';
import { nullableUuidString, optionalUuidString } from '../zod-helpers/index.js';
import { bomChargeCostSchema } from './bom-charge-cost-schema.js';
import { BOM_ITEM_TYPES_REQUIRING_PART } from './bom-item-types-requiring-part/index.js';
import { CHARGE_ONLY_COST_MESSAGE } from './charge-only-cost-message.js';
import { isCostOnNonChargeLine } from './is-cost-on-non-charge-line.js';
import { bomItemNameSchema, bomQuantitySchema } from './item-form.js';
import { UOM_REQUIRED_MESSAGE } from './uom-required-message.js';
// One recipe item nested inside CreateBomInput.items — same base fields as addBomItemInputSchema, minus bomId (implicit from the enclosing create call).
export const createBomItemInputSchema = z
    .object({
    partId: optionalUuidString('Invalid part selection.')
        .optional()
        .nullable()
        .transform((value) => value?.trim() || null),
    name: bomItemNameSchema,
    quantity: bomQuantitySchema,
    uomId: optionalUuidString('Invalid UOM selection.')
        .optional()
        .nullable()
        .transform((value) => value?.trim() || null)
        .optional(),
    typeId: z.enum(BOMItemType, 'Invalid BOM item type.'),
    cost: bomChargeCostSchema,
    linkAsDefault: z.boolean().optional(),
    confirmedAgainstBomId: nullableUuidString('Invalid BOM confirmation.').optional(),
})
    .superRefine((values, context) => {
    if (isCostOnNonChargeLine(values)) {
        context.addIssue({ code: 'custom', message: CHARGE_ONLY_COST_MESSAGE, path: ['cost'] });
    }
    if (!BOM_ITEM_TYPES_REQUIRING_PART.has(values.typeId))
        return;
    if (!values.partId) {
        context.addIssue({ code: 'custom', message: 'Part is required.', path: ['partId'] });
    }
    if (!values.uomId) {
        context.addIssue({ code: 'custom', message: UOM_REQUIRED_MESSAGE, path: ['uomId'] });
    }
});
//# sourceMappingURL=create-item-input.js.map